export const hardNavigate = (url: string) => void (location.href = url);
